export enum FixturePlayByPlayEventFilters {
  FixtureStatus = "fixtureStatus",
  DateRange = "dateRange",
}
